export const PREDEFINED_QUESTIONS: string[] = [
    'What is MDM?',
    'How can I fetch logs?',
    'How do I create a campaign?',
];
